export default __webpack_public_path__ + "static/media/pro_aim_chat.2054442e.png";